module.exports = __webpack_public_path__ + "img/Icone_Google_Meet.9d7d3135.svg";